import { FormField, SitecoreForm } from '@sitecore-jss/sitecore-jss-forms';
import { NextRouter } from 'next/router';

export interface FormVariantProps {
  fields: SitecoreForm;
  router: NextRouter;
  onNextForm: (fields: FormField[]) => void;
}
